import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImagemTituloDescricaoContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getImagemTituloDescricao(id: string): Observable<any> {
    return this.getImagemTituloDescricaoContents(id).pipe(
      map(res => this.buildResponseImagemTituloDescricaoObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryImagemTituloDescricaoContents[0].flatData;
  }

  private getImagemTituloDescricaoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryImagemTituloDescricaoContents(filter: "id eq '${id}'") {
          flatData {
            nome
            imagem {
              url
            }
            titulo
            descricao
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseImagemTituloDescricaoObject(data: any) {
    return {
      image: data.imagem && data.imagem[0]
          ? data.imagem[0].url
          : null,
      title: data.titulo ? data.titulo : null,
      description: data.descricao ? data.descricao : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
